import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import HorizontalSpacingToggleButton from './HorizontalSpacingToggleButton';
import ClientProvider from './client';
export default createDemo(import.meta.url, HorizontalSpacingToggleButton, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/toggle-button/demos/horizontal-spacing/HorizontalSpacingToggleButton.tsx",
    "fileName": "HorizontalSpacingToggleButton.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import * as React from 'react';\nimport FormatAlignLeftIcon from '@mui/icons-material/FormatAlignLeft';\nimport FormatAlignCenterIcon from '@mui/icons-material/FormatAlignCenter';\nimport FormatAlignRightIcon from '@mui/icons-material/FormatAlignRight';\nimport FormatAlignJustifyIcon from '@mui/icons-material/FormatAlignJustify';\nimport ToggleButton, { toggleButtonClasses } from '@mui/material/ToggleButton';\nimport ToggleButtonGroup, {\n  toggleButtonGroupClasses,\n} from '@mui/material/ToggleButtonGroup';\nimport { styled } from '@mui/material/styles';\n\nconst StyledToggleButtonGroup = styled(ToggleButtonGroup)(({ theme }) => ({\n  gap: '2rem',\n  [`& .${toggleButtonGroupClasses.firstButton}, & .${toggleButtonGroupClasses.middleButton}`]:\n    {\n      borderTopRightRadius: (theme.vars || theme).shape.borderRadius,\n      borderBottomRightRadius: (theme.vars || theme).shape.borderRadius,\n    },\n  [`& .${toggleButtonGroupClasses.lastButton}, & .${toggleButtonGroupClasses.middleButton}`]:\n    {\n      borderTopLeftRadius: (theme.vars || theme).shape.borderRadius,\n      borderBottomLeftRadius: (theme.vars || theme).shape.borderRadius,\n      borderLeft: `1px solid ${(theme.vars || theme).palette.divider}`,\n    },\n  [`& .${toggleButtonGroupClasses.lastButton}.${toggleButtonClasses.disabled}, & .${toggleButtonGroupClasses.middleButton}.${toggleButtonClasses.disabled}`]:\n    {\n      borderLeft: `1px solid ${(theme.vars || theme).palette.action.disabledBackground}`,\n    },\n}));\n\nexport default function HorizontalSpacingToggleButton() {\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus-unfocused",
            "dataFrameIndent": 0,
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "  const [alignment, setAlignment] = React.useState<string | null>('left');\n\n  const handleAlignment = (\n    event: React.MouseEvent<HTMLElement>,\n    newAlignment: string | null,\n  ) => {\n    setAlignment(newAlignment);\n  };\n\n  return (\n    <StyledToggleButtonGroup\n      value={alignment}\n      exclusive\n      onChange={handleAlignment}\n      aria-label=\"text alignment\"\n    >\n      <ToggleButton value=\"left\" aria-label=\"left aligned\">\n        <FormatAlignLeftIcon />\n      </ToggleButton>\n      <ToggleButton value=\"center\" aria-label=\"centered\">\n        <FormatAlignCenterIcon />\n      </ToggleButton>\n      <ToggleButton value=\"right\" aria-label=\"right aligned\">\n        <FormatAlignRightIcon />\n      </ToggleButton>\n      <ToggleButton value=\"justify\" aria-label=\"justified\" disabled>\n        <FormatAlignJustifyIcon />\n      </ToggleButton>\n    </StyledToggleButtonGroup>\n  );\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 62,
        "focusedLines": 0,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import * as React from 'react';\nimport FormatAlignLeftIcon from '@mui/icons-material/FormatAlignLeft';\nimport FormatAlignCenterIcon from '@mui/icons-material/FormatAlignCenter';\nimport FormatAlignRightIcon from '@mui/icons-material/FormatAlignRight';\nimport FormatAlignJustifyIcon from '@mui/icons-material/FormatAlignJustify';\nimport ToggleButton, { toggleButtonClasses } from '@mui/material/ToggleButton';\nimport ToggleButtonGroup, {\n  toggleButtonGroupClasses,\n} from '@mui/material/ToggleButtonGroup';\nimport { styled } from '@mui/material/styles';\n\nconst StyledToggleButtonGroup = styled(ToggleButtonGroup)(({ theme }) => ({\n  gap: '2rem',\n  [`& .${toggleButtonGroupClasses.firstButton}, & .${toggleButtonGroupClasses.middleButton}`]:\n    {\n      borderTopRightRadius: (theme.vars || theme).shape.borderRadius,\n      borderBottomRightRadius: (theme.vars || theme).shape.borderRadius,\n    },\n  [`& .${toggleButtonGroupClasses.lastButton}, & .${toggleButtonGroupClasses.middleButton}`]:\n    {\n      borderTopLeftRadius: (theme.vars || theme).shape.borderRadius,\n      borderBottomLeftRadius: (theme.vars || theme).shape.borderRadius,\n      borderLeft: `1px solid ${(theme.vars || theme).palette.divider}`,\n    },\n  [`& .${toggleButtonGroupClasses.lastButton}.${toggleButtonClasses.disabled}, & .${toggleButtonGroupClasses.middleButton}.${toggleButtonClasses.disabled}`]:\n    {\n      borderLeft: `1px solid ${(theme.vars || theme).palette.action.disabledBackground}`,\n    },\n}));\n\nexport default function HorizontalSpacingToggleButton() {\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus-unfocused",
          "dataFrameIndent": 0
        },
        "  const [alignment, setAlignment] = React.useState<string | null>('left');\n\n  const handleAlignment = (\n    event: React.MouseEvent<HTMLElement>,\n    newAlignment: string | null,\n  ) => {\n    setAlignment(newAlignment);\n  };\n\n  return (\n    <StyledToggleButtonGroup\n      value={alignment}\n      exclusive\n      onChange={handleAlignment}\n      aria-label=\"text alignment\"\n    >\n      <ToggleButton value=\"left\" aria-label=\"left aligned\">\n        <FormatAlignLeftIcon />\n      </ToggleButton>\n      <ToggleButton value=\"center\" aria-label=\"centered\">\n        <FormatAlignCenterIcon />\n      </ToggleButton>\n      <ToggleButton value=\"right\" aria-label=\"right aligned\">\n        <FormatAlignRightIcon />\n      </ToggleButton>\n      <ToggleButton value=\"justify\" aria-label=\"justified\" disabled>\n        <FormatAlignJustifyIcon />\n      </ToggleButton>\n    </StyledToggleButtonGroup>\n  );\n"
      ],
      [
        "span",
        "frame",
        "}\n"
      ]
    ],
    "totalLines": 62,
    "focusedLines": 0,
    "collapsible": true,
    "externals": [
      "react",
      "@mui/icons-material/FormatAlignLeft",
      "@mui/icons-material/FormatAlignCenter",
      "@mui/icons-material/FormatAlignRight",
      "@mui/icons-material/FormatAlignJustify",
      "@mui/material/ToggleButton",
      "@mui/material/ToggleButtonGroup",
      "@mui/material/styles"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
